module.exports = __webpack_public_path__ + "static/media/landing-bg.38f85adc.jpg";